// @index
export { default as InlineResourceForm } from './InlineResourceForm'
export { default as ResourceFormDialog } from './ResourceFormDialog'
export { default as ResourceFormModel } from './ResourceFormModel'
// /index

// @index(!FormModel): export type { Props as ${variable}Props} from ${relpath}
export type { Props as InlineResourceFormProps} from './InlineResourceForm'
export type { Props as ResourceFormDialogProps} from './ResourceFormDialog'
// /index